import en from './en.json'
import bg from './bg.json'

export default {
  en,
  bg,
}



// WEBPACK FOOTER //
// ./src/-client-app/i18n/index.js